<template>
  <div class="w-full">
    <div class="flex flex-row justify-between content-center mb-4">
      <div class="mx-auto container flex flex-row items-end space-x-2">
        <div class="flex-1">
          <input
            type="text"
            name="searchText"
            id="searchText"
            placeholder="Search by a title, keyword, tag, or YouTube ID..."
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            v-model="searchQuery"
          />
        </div>
        <!-- <div>
          <input
            type="date"
            name="startDate"
            id="searchText"
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            v-model="searchDate"
          />
        </div> -->

        <div>
          <select
            class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
            v-model="userId"
          >
            <option :value="null">All</option>
            <option
              v-for="stringer in stringers"
              :value="stringer.id"
              v-bind:key="stringer.id"
              >{{ stringer.name }}</option
            >
          </select>
        </div>

        <div>
          <select
            class="block w-full pl-3 pr-10 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
            v-model="searchFilter"
          >
            <option value="desc">Newest First</option>
            <option value="asc">Oldest First</option>
          </select>
        </div>
        <div class="space-x-2 h-full">
          <button
            class="px-4 py-2 bg-white rounded-md focus:outline-none sm:text-sm h-full"
            v-on:click="resetButtonClick()"
          >
            Reset
          </button>
        </div>
        <div class="rounded-md overflow-hidden hidden lg:inline-block h-full">
          <button
            class="focus:outline-none py-2.5 px-4 h-full"
            :class="{
              'bg-white text-black': display !== '2col',
              'bg-gray-600 text-white': display == '2col'
            }"
            v-on:click="display = '2col'"
          >
            <i class="fa-solid fa-grid-2 flex items-center justify-center"></i>
          </button>
          <button
            class="focus:outline-none py-2.5 px-4 h-full"
            :class="{
              'bg-white text-black': display !== 'full',
              'bg-gray-600 text-white': display == 'full'
            }"
            v-on:click="display = 'full'"
          >
            <i class="fa-solid fa-bars flex items-center justify-center"></i>
          </button>
        </div>
      </div>
    </div>
    <div
      class="grid grid-cols-1 gap-4"
      :class="{
        'lg:grid-cols-1': display == 'full',
        'lg:grid-cols-2': display == '2col'
      }"
    >
      <div
        class="bg-white rounded-md shadow-md flex flex-row p-2 relative overflow-hidden group select-none"
        v-for="video in videos"
        v-bind:key="video.id"
      >
        <!-- Hover over animation -->
        <div
          class="absolute w-full h-full backdrop-filter backdrop-blur-sm z-30 -m-2 opacity-0 group-hover:opacity-100 transition-all flex flex-row content-center justify-center items-center space-x-4"
        >
          <div
            class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
            v-on:click="viewVideo(video)"
          >
            <i class="fa-solid fa-eye"></i>
          </div>
          <div
            class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
            v-on:click="downloadVideo(video.id)"
          >
            <i class="fa-solid fa-download"></i>
          </div>
        </div>

        <div
          class="flex-none flex flex-col items-center content-center w-48 relative"
        >
          <div
            class="absolute top-0 left-0 mt-2 ml-2 bg-blue-500 rounded-md text-white z-10 text-xs px-1.5 py-0.5"
          >
            {{ video.length | timecode }}
          </div>
          <progressive-img
            class="rounded-md z-0"
            style="aspect-ratio: 16 / 9;"
            fallback="/static/image-unavailable.png"
            :src="video.thumbnailUrl"
          />
        </div>

        <div
          class="flex flex-col pl-2 whitespace-nowrap overflow-ellipsis overflow-hidden relative"
        >
          <div class="flex flex-row">
            <p
              class="whitespace-nowrap overflow-ellipsis overflow-hidden flex-1"
            >
              <strong class="text-red-600" v-if="video.status == 'pending'"
                >PENDING</strong
              >
              {{ video.title }}
            </p>
          </div>

          <div class="flex flex-row flex-wrap space-x-4 -m-1">
            <div class="m-1">
              <i class="fa-regular fa-user text-gray-500"></i>
              {{ video.user.name }}
            </div>
            <div class="m-1">
              <i class="fa-regular fa-clock text-gray-500"></i>
              {{ video.created_at | displayLocalDateTime }}
            </div>
            <div class="m-1">
              <i class="fa-regular fa-tag text-gray-500"></i>
              {{
                video.tags !== null
                  ? video.tags.length > 1
                    ? video.tags.length + " tags"
                    : video.tags.length + " tag"
                  : "0 tags"
              }}
            </div>
            <div class="m-1">
              <i class="fa-regular fa-earth-americas text-gray-500"></i>
              {{
                video.locations !== null
                  ? video.locations.length > 1
                    ? video.locations.length + " locations"
                    : video.locations.length + " location"
                  : "0 locations"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="loadMoreDiv" class="h-10"></div>
    <ViewVideoModal />
  </div>
</template>

<script>
import * as Config from "@/config";
import { mapGetters } from "vuex";
import moment from "moment";
import ViewVideoModal from "@/screens/stringer/modals/ViewVideoModal";

export default {
  name: "SocialMediaLatest",
  data() {
    return {
      videos: [],
      interval: null,
      loading: true,

      display: "2col",
      bottom: false,
      interval: null,
      shouldLoadMore: null,
      searchDate: null,
      stringers: [],
      userId: null,

      resource_url: Config.apiPath + "/api/v2/stringer/smteam/latest",
      searchQuery: "",
      current_page: 1,
      last_page: null,
      searching: false,
      searchDebounce: null,
      searchFilter: "desc"
    };
  },
  components: {
    ViewVideoModal
  },
  mounted() {
    this.$nextTick(async () => {
      await this.search();
      await this.getStringers();
      this.handleScroll();

      this.$eventBus.$on("scroll", this.bottomVisible);
      this.shouldLoadMore = setInterval(
        function() {
          this.bottomVisible();
        }.bind(this),
        250
      );
    });
  },
  destroyed() {
    this.$eventBus.$off("scroll");
    clearInterval(this.shouldLoadMore);
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),

    async getStringers() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/users/stringer_list"
      );
      this.$set(this, "stringers", res.data);
    },

    computeResourceUrl() {
      var baseURL = this.resource_url + "?page=" + this.current_page;

      if (this.searchQuery !== "" && this.searchQuery !== null) {
        baseURL += "&search=" + this.searchQuery;
      }

      if (this.userId !== "" && this.userId !== null) {
        baseURL += "&userId=" + this.userId;
      }

      if (this.searchFilter !== null) {
        baseURL += "&orderBy=" + this.searchFilter;
      }

      return baseURL;
    },

    async search() {
      let url = this.computeResourceUrl();

      if (this.fetching) return;
      this.fetching = true;
      try {
        let res = await this.$http.get(url);
        this.current_page = res.data.current_page + 1;
        this.videos = this.videos.concat(res.data.data);
        this.searching = false;
        this.fetching = false;
      } catch (e) {
        this.searching = false;
        this.fetching = false;
        this.addToastMessage({
          title: "Error",
          text: "We have encountered an error loading more videos, try again.",
          type: "error"
        });
      }
    },

    downloadVideo(id) {
      var self = this;
      this.$http
        .get(
          Config.apiPath + "/api/v2/stringer/smteam/download/" + id,
          this.getAuthorizationHeader()
        )
        .then(response => {
          if (response.data !== 400) {
            var link = document.createElement("a");
            document.body.appendChild(link);
            link.href = response.data;
            link.click();
            document.body.removeChild(link);
          } else {
            self.$swal("Uh oh!", "There has been an issue.", "error");
          }
        });
    },
    bottomVisible() {
      const rect = this.$refs.loadMoreDiv.getBoundingClientRect();

      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      this.bottom = isInViewport;

      return isInViewport;
    },
    reset() {
      this.current_page = 1;
      this.videos = [];
    },
    async resetButtonClick() {
      this.searchQuery = null;
      this.searchFilter = "desc";
      await this.reset();
      await this.search();
    },
    viewVideo(video) {
      this.$eventBus.$emit("stringer-view-video-open-modal", video);
    },
    handleScroll() {
      this.bottom = this.bottomVisible();
    }
  },
  watch: {
    searchQuery: function() {
      this.reset();
      this.searching = true;
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.search();
      }, 600);
    },
    searchFilter: function() {
      this.reset();
      this.searching = true;
      this.search();
    },
    userId: function() {
      this.reset();
      this.searching = true;
      this.search();
    },
    bottom: function(isAtBottom) {
      if (isAtBottom) {
        this.search();
      }
    }
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  },
  filters: {
    timecode: function(value) {
      if (value !== null) {
        var seconds = Math.floor(value % 60).toString();
        var minutes = Math.floor(value / 60).toString();
        if (seconds.length === 1) {
          seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
      }
    },
    displayLocalDateTime: function(date) {
      return moment
        .utc(date)
        .local()
        .format("M/D/YY, h:mm a");
    }
  }
};
</script>

<style scoped>
.filter {
  background-color: #fff;
  border-radius: 6px;
  min-height: 20px;
  width: 100%;
  height: auto;
}

.max-w-200 {
  max-width: 200px;
  height: auto;
}

.last-update {
  font-size: 16px;
}

.text-transform-none {
  text-transform: none;
}
</style>
